import React from 'react';

export default class Table extends React.Component {

  generateSpanCols() {
    var spancols = this.props.spancols;  // [{key, label}]


    // generate our header (th) cell components
    return spancols.map(function(item) {
        return <th colSpan={item.span} style={{textAlign: item.textAlign}}> {item.name} </th>;
    });
  }

  generateHeaders() {
   var cols = this.props.cols;  // [{key, label}]

   // generate our header (th) cell components
   return cols.map(function(colData) {
       return <th key={colData.key} style={{textAlign: colData.textAlign}}> {colData.label} </th>;
   });
  }

  generateRows() {
    var cols = this.props.cols,  // [{key, label}]
        data = this.props.data;

    return data.map(function(item) {
        // handle the column data within each row
        var cells = cols.map(function(colData) {
            // colData.key might be "firstName"
            return <td> {item[colData.key]} </td>;
        });
        return <tr key={item.id}> {cells} </tr>;
    });
  }

  render() {

    var headerComponents = this.generateHeaders();
    var rowComponents = this.generateRows();

      return (
          <table>
              <thead>
                <tr>{this.generateSpanCols()}</tr>
                <tr>{headerComponents}</tr>
              </thead>
              <tbody> {rowComponents} </tbody>
          </table>
      );
  }
}
